module.exports = __webpack_public_path__ + "static/media/ULTRAFOMO.1f7629f7.png";